/* Somnila v7: behaviours for the sv7-* sections (PurePeptide architecture).
   Add to cart always goes through Shrine's own <product-form>, so the theme's cart drawer opens as usual.
   v14 : aucun nom de coloris ni aucun mot affiché en dur ici. Les libellés viennent de la page (data-label, JSON des offres,
   tirés de la table unique snippets/sv14-colour.liquid) et les mots (En stock, Épuisé, Indisponible…) des locales,
   par les attributs data-sv7-t-* de la fiche. Les coloris sont comparés par leur code (k), jamais par leur nom. */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var json = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
  /* Mots affichés : attributs data-sv7-t-* posés par Liquid (clés somnila_v9.pdp.*), avec un texte de secours. */
  function words(root) {
    var d = (root && root.dataset) || {};
    return {
      available: d.sv7TAvailable || 'En stock',
      soldOut: d.sv7TSoldOut || 'Épuisé',
      unavailable: d.sv7TUnavailable || 'Indisponible',
      availableIn: d.sv7TAvailableIn || 'Disponible en : [coloris]',
      addonPick: d.sv7TAddonPick || 'Choisissez le coloris de la housse.',
      withCover: d.sv7TWithCover || '',
      stickCover: d.sv7TStickCover || ''
    };
  }
  function checkedLabel(input) { return input ? (input.getAttribute('data-label') || input.value) : ''; }

  /* Product cards: colour dots and the 1 / 2 pillow chips choose what "Add" puts in the cart. */
  function initCard(card) {
    if (card.dataset.sv7Ready) return;
    var data = json($('script[data-sv7-card-data]', card) || { textContent: 'null' }); if (!data) return;
    card.dataset.sv7Ready = '1';
    var idInput = $('input[name="id"]', card), price = $('[data-sv7-price]', card), unit = $('[data-sv7-unit]', card);
    var add = $('[data-sv7-add]', card), cname = $('[data-sv7-cname]', card);
    var addLabel = add && $('.button__label', add), addLabelHTML = addLabel && addLabel.innerHTML;
    function colour() { var c = $('.sv7-dots input:checked', card); return c ? c.value : null; }
    function set() { var q = $('.sv7-chips input:checked', card); return q ? +q.value : 0; }
    function pick(list, col) {
      var i, v = null;
      if (col) for (i = 0; i < list.length; i++) if (list[i].c === col && list[i].a) { v = list[i]; break; }
      if (!v && col) for (i = 0; i < list.length; i++) if (list[i].c === col) { v = list[i]; break; }
      if (col) return v;
      for (i = 0; i < list.length; i++) if (list[i].a) return list[i];
      return list[0] || null;
    }
    function update() {
      var s = set(), list = data.sets[s] || data.sets[0], v = pick(list, colour());
      var W = words(card), available = !!(v && v.a), state = v ? W.soldOut : W.unavailable;
      if (idInput) { idInput.value = v ? v.id : ''; idInput.disabled = !available; }
      if (price) price.textContent = v ? v.m : state;
      if (unit) unit.textContent = v ? (s ? (unit.dataset.pair || '') : (unit.dataset.single || '')) : '';
      if (add) { add.disabled = !available; add.setAttribute('aria-disabled', String(!available)); }
      if (addLabel) { if (available) addLabel.innerHTML = addLabelHTML; else addLabel.textContent = state; }
      if (cname) cname.textContent = checkedLabel($('.sv7-dots input:checked', card));
      $$('.sv7-dots input', card).forEach(function (input) {
        var option = pick(list, input.value), off = !(option && option.a);
        input.disabled = off;
        var label = input.closest('.sv7-dot'); if (label) label.classList.toggle('is-off', off);
      });
      var url = data.urls[s] || data.urls[0];
      $$('[data-sv7-link]', card).forEach(function (a) { a.href = url + (v ? '?variant=' + v.id : ''); });
    }
    $$('.sv7-dots input, .sv7-chips input', card).forEach(function (i) { i.addEventListener('change', update); });
    update();
  }

  /* Two heights: accessible tabs; the side view flips for the side / back tabs. */
  function initTabs(root) {
    if (root.dataset.sv7TabsReady) return; root.dataset.sv7TabsReady = '1';
    var tabs = $$('[role="tab"]', root), fig = $('.sv7-fig', root);
    function select(t, focus) {
      tabs.forEach(function (x) {
        var on = x === t; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1;
        var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (fig && (t.dataset.state === 'side' || t.dataset.state === 'back')) fig.dataset.state = t.dataset.state;
      if (focus) t.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        else if (k === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (k === 'Home') n = tabs[0]; else if (k === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* Product page: options + set tile + quantity choose what the theme's form adds.
     v14 : paliers grisés quand le coloris manque dans le pack (« Disponible en : … »), jamais de coloris remplacé en silence ;
     ?offre=2 / ?offre=3 (nombre de pièces) en plus de ?offer=<adresse du pack> ; case housse de rechange non cochée. */
  function initProduct(root) {
    if (root.dataset.sv7ProductReady) return;
    var offers = json($('script[data-sv7-offers]', root) || { textContent: 'null' }); if (!offers || !offers.length) return;
    root.dataset.sv7ProductReady = '1';
    var W = words(root);
    var base = offers[0], idInput = $('form input[name="id"]', root), qtyField = $('[data-sv7-qty-field]', root);
    var priceEl = $('[data-sv7-price]', root), unitEl = $('[data-sv7-unit]', root), btnPrice = $('[data-sv7-btn-price]', root);
    var atc = $('[data-sv7-atc]', root), stock = $('[data-sv7-stock]', root), mainImg = $('[data-sv7-main]', root);
    var atcLabel = atc && $('.button__label', atc), atcLabelHTML = atcLabel && atcLabel.innerHTML, express = $('.sv7-express', root);
    var expressOr = express && express.previousElementSibling && express.previousElementSibling.classList.contains('sv7-or') ? express.previousElementSibling : null;
    var stickPrice = $('[data-sv7-stick-price]'), stickImg = $('[data-sv7-stick-img]'), stickName = $('[data-sv9-stick-name]');
    var nOpts = base.variants[0] ? base.variants[0].o.length : 0;
    var cIdx = typeof base.ci === 'number' ? base.ci : -1;
    var qIn = $('[data-sv7-qty-input]', root);
    var addon = $('[data-sv7-addon]', root), addonCheck = addon && $('[data-sv7-addon-check]', addon);
    var addonPick = addon && $('[data-sv7-addon-pick]', addon), addonNote = addon && $('[data-sv7-addon-note]', addon);
    var addonName = addon && $('[data-sv7-addon-colour]', addon), addonRadios = addon ? $$('input[type="radio"]', addon) : [];
    /* Retouches de design (01/10), partie 2 : case housse cochée, le prix affiché (carte d'achat, barre collante) est le total,
       produit + housse ; la note « Non cochée : vous choisissez » se cache ; la ligne sous le prix détaille le total. */
    var addonHint = addon && $('.sv16-addon-note', addon), coverLine = $('[data-sv16-cover-line]', root), last = { v: null, o: base, t: 0 };
    /* Format des prix : celui de la boutique (data-sv7-money) ; à défaut, déduit d'un prix déjà écrit par Shopify (v.m). */
    function money(cents, sample) {
      var fmt = (root.dataset.sv7Money || '').trim();
      if (!/\{\{\s*\w+\s*\}\}/.test(fmt)) {
        var m = /\d[\d.,\s\u00a0\u202f']*/.exec(sample || '');
        if (!m) return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0€';
        var num = m[0].replace(/[\s\u00a0\u202f]+$/, '');
        var kind = /,\d{2}$/.test(num) ? 'amount_with_comma_separator' : (/\.\d{2}$/.test(num) ? 'amount' : (/,/.test(num) ? 'amount_no_decimals_with_comma_separator' : 'amount_no_decimals'));
        fmt = sample.slice(0, m.index) + '{{' + kind + '}}' + sample.slice(m.index + num.length);
      }
      var k = /\{\{\s*(\w+)\s*\}\}/.exec(fmt);
      function d(n, prec, th, dec) { var x = (n / 100).toFixed(prec).split('.'); return x[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (x[1] ? dec + x[1] : ''); }
      var out;
      switch (k[1]) {
        case 'amount': out = d(cents, 2, ',', '.'); break;
        case 'amount_no_decimals': out = d(cents, 0, ',', '.'); break;
        case 'amount_no_decimals_with_comma_separator': out = d(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': out = d(cents, 2, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = d(cents, 2, "'", '.'); break;
        default: out = d(cents, 2, '.', ',');
      }
      return fmt.replace(k[0], out);
    }
    function show(el, on) { if (!el) return; el.hidden = !on; el.style.display = on ? '' : 'none'; }
    function paintPrice() {
      var v = last.v, o = last.o || base, t = last.t, state = v ? W.soldOut : W.unavailable;
      var on = !!(addon && addonCheck && addonCheck.checked && !addon.hidden), r = addonChoice();
      var coverP = r && r.getAttribute('data-p') ? +r.getAttribute('data-p') : (addon ? +addon.getAttribute('data-price') || 0 : 0);
      var baseP = v ? v.p * (t > 0 ? 1 : qty()) : 0, total = !!(on && v && W.withCover);
      var txt = v ? (total ? money(baseP + coverP, v.m) : v.m) : state, name = o.name || root.dataset.sv9Name || '';
      if (priceEl) priceEl.textContent = txt;
      if (stickPrice) stickPrice.textContent = txt;
      if (stickName) stickName.textContent = total && W.stickCover ? W.stickCover.replace('§N§', name) : name;
      if (unitEl) { unitEl.textContent = v ? (o.unit || '') : ''; show(unitEl, !total); }
      if (coverLine) { coverLine.textContent = total ? W.withCover.replace('§P§', money(baseP, v.m)).replace('§C§', money(coverP, v.m)) : ''; show(coverLine, total); }
      show(addonHint, !on);
    }

    function selected() { var out = []; for (var i = 0; i < nOpts; i++) { var c = $('input[name="sv7-opt-' + i + '"]:checked', root); out.push(c ? c.value : null); } return out; }
    function tier() { var t = $('input[name="sv7-tier"]:checked', root); return t ? +t.value : 0; }
    function qty() { return qIn ? Math.max(1, +qIn.value || 1) : 1; }
    /* Code du coloris choisi (table sv14-colour) : le même pour « Night » et « Bleu marine ». */
    function colourCode() {
      if (cIdx < 0) return null;
      var c = $('input[name="sv7-opt-' + cIdx + '"]:checked', root);
      return c ? (c.getAttribute('data-k') || c.value) : null;
    }
    function baseVariant(sel) {
      for (var i = 0; i < base.variants.length; i++) {
        var v = base.variants[i], ok = true;
        for (var j = 0; j < nOpts; j++) if (sel[j] !== null && v.o[j] !== sel[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    /* Variante d'un pack au coloris choisi, par code. Aucun autre coloris n'est pris à sa place : sans ce coloris, null. */
    function offerVariant(o, code) {
      var i, list = o.variants || [];
      if (typeof o.ci !== 'number' || o.ci < 0 || !code) {
        for (i = 0; i < list.length; i++) if (list[i].a) return list[i];
        return list[0] || null;
      }
      for (i = 0; i < list.length; i++) if (list[i].k === code && list[i].a) return list[i];
      for (i = 0; i < list.length; i++) if (list[i].k === code) return list[i];
      return null;
    }
    function availableLabels(o) {
      var seen = {}, out = [];
      (o.variants || []).forEach(function (v) { if (v.a && v.l && !seen[v.k]) { seen[v.k] = 1; out.push(v.l); } });
      return out;
    }
    /* Paliers : grisés, avec « Disponible en : … », quand le pack n'existe pas (ou plus) dans le coloris choisi. */
    function markTiers(code) {
      $$('input[name="sv7-tier"]', root).forEach(function (inp) {
        var i = +inp.value, o = offers[i]; if (!i || !o) return;
        var ov = offerVariant(o, code), ok = !!(ov && ov.a);
        var lab = inp.closest('.sv7-tileopt'), note = lab && $('[data-sv7-tier-note]', lab);
        if (lab) lab.classList.toggle('is-off', !ok);
        inp.disabled = !ok && !inp.checked;
        if (note) {
          var names = ok ? [] : availableLabels(o);
          note.textContent = ok ? '' : (names.length ? W.availableIn.replace('[coloris]', names.join(', ')) : W.unavailable);
          note.hidden = ok;
        }
      });
    }
    function selectImage(src, alt, isScene) {
      if (!mainImg) return;
      mainImg.src = src; mainImg.alt = alt || ''; mainImg.style.opacity = 1;
      mainImg.dataset.sv7Scene = isScene ? 'true' : 'false';
      $$('[data-sv7-thumb]', root).forEach(function (thumb) { thumb.setAttribute('aria-current', String(thumb.dataset.src === src)); });
    }
    function update(fromOption) {
      var sel = selected(), bv = baseVariant(sel), t = tier(), o = offers[t] || base, v = bv, code = colourCode();
      if (t > 0) v = offerVariant(o, code);
      last = { v: v, o: o, t: t };
      var available = !!(v && v.a), state = v ? W.soldOut : W.unavailable;
      if (idInput) { idInput.value = v ? v.id : ''; idInput.disabled = !available; }
      if (priceEl) priceEl.textContent = v ? v.m : state;
      if (stickPrice) stickPrice.textContent = v ? v.m : state;
      if (stickName) stickName.textContent = o.name || root.dataset.sv9Name || '';
      if (unitEl) unitEl.textContent = v ? (o.unit || '') : '';
      /* v14 (cahier § 6.2, point 10) : mini-fiche « Avant de payer » (snippets/sv16-before.liquid), si elle est sur la page. */
      var bfPrice = $('[data-sv16-before-price]', root); if (bfPrice) bfPrice.textContent = v ? v.m : state;
      var bfUnit = $('[data-sv16-before-unit]', root); if (bfUnit) bfUnit.textContent = v ? (o.unit || '') : '';
      if (atc) { atc.disabled = !available; atc.setAttribute('aria-disabled', String(!available)); }
      if (atcLabel) { if (available) atcLabel.innerHTML = atcLabelHTML; else atcLabel.textContent = state; }
      btnPrice = $('[data-sv7-btn-price]', root);
      if (btnPrice && v) btnPrice.textContent = v.m;
      if (stock) { stock.textContent = available ? W.available : state; stock.classList.toggle('is-out', !available); }
      sel.forEach(function (val, i) {
        var n = $('[data-sv7-optname="' + i + '"]', root);
        if (n) n.textContent = checkedLabel($('input[name="sv7-opt-' + i + '"]:checked', root)) || val || '';
      });
      if (fromOption && bv && bv.img && mainImg) {
        selectImage(bv.img, bv.alt, false);
        if (stickImg) stickImg.src = bv.img;
      }
      markTiers(code);
      var url = new URL(location.href);
      if (bv) url.searchParams.set('variant', bv.id); else url.searchParams.delete('variant');
      url.searchParams.delete('offer'); url.searchParams.delete('offre');
      if (t > 0) { if (o.n > 1) url.searchParams.set('offre', o.n); else url.searchParams.set('offer', o.handle); }
      history.replaceState(null, '', url.pathname + url.search + url.hash);
      syncAddon(code, v, t, available);
    }
    /* Case housse de rechange : jamais cochée d'office ; son coloris suit celui de l'oreiller s'il existe en housse,
       sinon rien n'est choisi et la cliente choisit. Masquée avec 3 pièces ou plus, ou au-delà du seuil (IOSS).
       L'ajout lui-même est fait par le formulaire du thème, qui lit data-selected et data-id de la case. */
    function addonChoice() { for (var i = 0; i < addonRadios.length; i++) if (addonRadios[i].checked) return addonRadios[i]; return null; }
    function syncAddonState() {
      var off = !!(express && express.dataset.sv14Off === '1');
      if (!addon) { if (express) express.hidden = off; return; }
      var on = !!(addonCheck && addonCheck.checked && !addon.hidden), r = addonChoice();
      if (addonPick) addonPick.hidden = !on;
      if (addonName) addonName.textContent = checkedLabel(r);
      addon.dataset.selected = String(on && !!r);
      addon.dataset.id = on && r ? r.value : '';
      if (addonNote && (!on || r)) addonNote.hidden = true;
      /* Le paiement express n'ajouterait pas la housse : il est caché tant que la case est cochée. */
      var hideExpress = off || on;
      if (express) express.hidden = hideExpress;
      if (expressOr) expressOr.hidden = hideExpress;
      paintPrice();
    }
    function syncAddon(code, v, t, available) {
      if (express) express.dataset.sv14Off = available ? '' : '1';
      if (addon) {
        var o = offers[t] || base, pieces = t > 0 ? (o.n || 1) : qty();
        var amount = (v && v.p ? v.p : 0) * (t > 0 ? 1 : qty());
        var max = +addon.getAttribute('data-max') || 0, coverP = +addon.getAttribute('data-price') || 0;
        var hide = pieces >= 3 || (max > 0 && amount + coverP > max);
        addon.hidden = hide;
        if (hide && addonCheck) addonCheck.checked = false;
        if (!addon.dataset.userPick) {
          var match = null;
          addonRadios.forEach(function (r) { if (!match && !r.disabled && code && r.getAttribute('data-k') === code) match = r; });
          addonRadios.forEach(function (r) { r.checked = r === match; });
        }
      }
      syncAddonState();
    }
    if (addon) {
      if (addonCheck) addonCheck.addEventListener('change', function () {
        if (!addonCheck.checked) delete addon.dataset.userPick;
        update(false);
      });
      addonRadios.forEach(function (r) { r.addEventListener('change', function () { addon.dataset.userPick = '1'; syncAddonState(); }); });
      /* Case cochée sans coloris choisi : rien n'est envoyé et on le dit (écouteur en capture, avant celui du thème). */
      root.addEventListener('submit', function (e) {
        if (!addonCheck || !addonCheck.checked || addon.hidden || addonChoice()) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (addonNote) { addonNote.textContent = W.addonPick; addonNote.hidden = false; }
        var first = addonRadios.filter(function (r) { return !r.disabled; })[0]; if (first) first.focus();
      }, true);
    }
    $$('input[name^="sv7-opt-"]', root).forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
    $$('input[name="sv7-tier"]', root).forEach(function (i) { i.addEventListener('change', function () { update(false); }); });

    function setQty(n) { n = Math.max(1, Math.min(20, n | 0 || 1)); if (qIn) qIn.value = n; if (qtyField) qtyField.value = n; if (addon) update(false); }
    $$('[data-sv7-qty]', root).forEach(function (b) { b.addEventListener('click', function () { setQty((+qIn.value || 1) + (+b.dataset.sv7Qty)); }); });
    if (qIn) qIn.addEventListener('change', function () { setQty(+qIn.value); });

    $$('[data-sv7-thumb]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        selectImage(b.dataset.src, b.dataset.alt, b.dataset.sv7Scene === 'true');
      });
    });

    /* Palier demandé par l'adresse : ?offre=2 ou ?offre=3 (nombre de pièces), ou l'ancien ?offer=<adresse du pack>.
       A6 : ?offer= reconnaît l'adresse actuelle du pack et son code interne (ancienne adresse : ?offer=for-two continue de marcher). */
    var params = new URLSearchParams(location.search), want = params.get('offer'), wantN = parseInt(params.get('offre'), 10), picked = -1;
    if (wantN > 1) offers.forEach(function (o, i) { if (picked < 0 && i > 0 && o.n === wantN) picked = i; });
    if (picked < 0 && want) offers.forEach(function (o, i) { if (picked < 0 && i > 0 && (o.handle === want || o.code === want)) picked = i; });
    if (picked > 0) { var pr = $('input[name="sv7-tier"][value="' + picked + '"]', root); if (pr) pr.checked = true; }
    update(false);
  }

  /* Sticky bar on the product page: shows once the main button has scrolled away. */
  var stickyBar, stickyRef, cleanupStick;
  function initStick() {
    var bar = $('.sv7-stick'), ref = $('[data-sv7-atc]');
    if (bar === stickyBar && ref === stickyRef) return;
    if (cleanupStick) cleanupStick();
    stickyBar = bar; stickyRef = ref;
    if (!bar || !ref) return;
    var btn = $('[data-sv7-stick-btn]', bar);
    var label = btn && (btn.dataset.sv7Label || btn.textContent);
    if (btn) btn.dataset.sv7Label = label;
    function sync() {
      if (!btn) return;
      var unavailable = ref.disabled, busy = ref.getAttribute('aria-disabled') === 'true';
      var stock = $('[data-sv7-stock]', ref.closest('.sv7-pdp'));
      btn.disabled = unavailable || busy;
      btn.setAttribute('aria-disabled', String(btn.disabled));
      btn.textContent = unavailable && stock ? stock.textContent : label;
    }
    function add() { if (!ref.disabled && ref.getAttribute('aria-disabled') !== 'true') ref.click(); }
    if (btn) btn.addEventListener('click', add);
    function onScroll() {
      var r = ref.getBoundingClientRect(), foot = $('.sv7-foot'), end = foot && foot.getBoundingClientRect().top < innerHeight;
      /* v14 (cahier § 6.2) : la barre paraît aussi au premier écran du téléphone quand le bouton principal est plus bas. */
      var on = (r.bottom < 0 || r.top > innerHeight) && !end;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); if (btn) btn.tabIndex = on ? 0 : -1;
    }
    var observer = new MutationObserver(sync);
    observer.observe(ref, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    addEventListener('scroll', onScroll, { passive: true }); addEventListener('resize', onScroll); onScroll(); sync();
    cleanupStick = function () {
      observer.disconnect();
      removeEventListener('scroll', onScroll); removeEventListener('resize', onScroll);
      if (btn) btn.removeEventListener('click', add);
      cleanupStick = null;
    };
  }

  /* A5, partie 2 : un bouton portant data-sv7-offre="2" (bloc « À deux » de la fiche héros) coche le palier de 2 pièces
     en haut de la page et y ramène, au lieu de recharger la page. Sans palier correspondant sur la page, le lien est suivi
     normalement (?offre=2 coche le même palier au chargement). Rien n'est ajouté au panier. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-sv7-offre]') : null;
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var n = parseInt(a.getAttribute('data-sv7-offre'), 10), root = $('.sv7-pdp');
    var data = root && json($('script[data-sv7-offers]', root) || { textContent: 'null' });
    if (!(n > 1) || !data) return;
    var idx = -1;
    data.forEach(function (o, i) { if (idx < 0 && i > 0 && o.n === n) idx = i; });
    var input = idx > 0 ? $('input[name="sv7-tier"][value="' + idx + '"]', root) : null;
    if (!input) return;
    e.preventDefault();
    input.disabled = false;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    var box = input.closest('.sv10-offers') || root;
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
    try { input.focus({ preventScroll: true }); } catch (err) { input.focus(); }
  });

  function boot() {
    $$('[data-sv7-card]').forEach(initCard);
    $$('.sv7-heights').forEach(initTabs);
    $$('.sv7-pdp').forEach(initProduct);
    $$('[data-sv7-sort]').forEach(function (s) {
      s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
    });
    $$('form[data-sv7-loc] select').forEach(function (s) { s.addEventListener('change', function () { s.form.submit(); }); });
    initStick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
